<div class="router-venue">
  <div class="venue-page-header submenu-router">
    <div class="venue-breadcrumb">
      <h1 class="m-0 title-submenu">Espacios</h1>
      <mat-divider [vertical]="true" class="breadcrumb-divider"></mat-divider>
      <h1 class="m-0 title-submenu venue-name-subtitle">{{venue?.name}}</h1>
    </div>
    <mat-divider></mat-divider>
  </div>
  <div class="venue-panel-container page-panel">
    <div class="btn-back-detail" (click)="goBack()">
        <i class="fal fa-arrow-left"></i>
        <span>Ver todos los espacios</span>
    </div>
    <div class="card-white-panel">
      <div>
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
